import { h } from "../dom.ts";
import { t } from "../i18n/index.ts";
import { languageSelect } from "../i18n/lang.ts";
import { themeSelect } from "../theme.ts";
import { isMuted, setMuted } from "../sound.ts";
import { premoveToggle } from "../game/premove.ts";
import { analysisDepthSelect } from "../engine/analysisDepth.ts";
import { boardThemePicker } from "./boardTheme.ts";
import { listenWhileMounted } from "./lifecycle.ts";

export function soundToggle(): HTMLElement {
  const field = h(`<label class="field field-toggle"><span>${t("settings.sound")}</span><input name="sound" type="checkbox" /></label>`);
  const input = field.querySelector("input")!;
  input.checked = !isMuted();
  input.onchange = () => setMuted(!input.checked);
  listenWhileMounted(field, "soundchange", () => { input.checked = !isMuted(); });
  return field;
}

export function appearancePreferences(): HTMLElement {
  const root = h(`<section class="panel"><h2>${t("settings.appearanceGroup")}</h2></section>`);
  root.append(languageSelect(), themeSelect(), soundToggle());
  return root;
}

export function boardPreferences(mode: "play" | "analysis" | "replay" | "all"): HTMLElement {
  const root = h(`<div class="board-preferences"><p class="label">${t("settings.boardTheme")}</p></div>`);
  root.append(boardThemePicker());
  if (mode === "play" || mode === "all") root.append(premoveToggle());
  if (mode === "analysis" || mode === "all") root.append(analysisDepthSelect());
  return root;
}

/** Immediate controls only: no navigation or reload of a running board. */
export function boardSettings(mode: "play" | "analysis" | "replay"): HTMLElement {
  const root = h(`<details class="board-settings"><summary>${t("settings.boardSettings")}</summary></details>`);
  root.append(themeSelect(), soundToggle(), boardPreferences(mode));
  return root;
}
